/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_OverlineInputs */

const en_mk_aicost_overline = /** @type {(inputs: Mk_Aicost_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI cost`)
};

const id_mk_aicost_overline = /** @type {(inputs: Mk_Aicost_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya AI`)
};

/**
* | output |
* | --- |
* | "AI cost" |
*
* @param {Mk_Aicost_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_overline = /** @type {((inputs?: Mk_Aicost_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_overline(inputs)
	return en_mk_aicost_overline(inputs)
});